export const DEFAULT_API_BASE_URL = 'https://lpqcvefosqhrceocfxxk.supabase.co/functions/v1';

export const COOKIE_EXPIRY_DAYS = 365;

export const TYPING_ANIMATION_INTERVAL = 400;
export const MESSAGE_SEGMENT_DELAY = 120;
export const TOAST_DURATION = 3000;
export const BUBBLE_ACTIVE_DURATION = 250;
export const CAROUSEL_INIT_DELAY = 100;
export const INPUT_FOCUS_DELAY = 100;

export const SWIPE_THRESHOLD = 50;
export const MAX_SEGMENT_COUNT = 10;
export const MIN_SEGMENT_COUNT = 3;
export const CHARS_PER_SEGMENT = 150;

export const PRICE_CONTEXT_RANGE = 200;
export const DESCRIPTION_CONTEXT_RANGE = 300;
export const MAX_OG_DESCRIPTION_LENGTH = 150;
export const MIN_DESCRIPTION_LENGTH = 20;
export const MAX_DESCRIPTION_LENGTH = 200;

export const RATE_LIMIT_INTERVAL = 1000;
export const MAX_RETRIES = 3;
export const RETRY_BASE_DELAY = 1000;

export const REQUEST_TIMEOUT_MS = 60000;
export const STREAM_INACTIVITY_TIMEOUT_MS = 30000;
export const MAX_HISTORY_MESSAGES = 200;
